import login_create_account_image from '../../images/LoginCreateAccount.png';
import feedback_button from '../../images/Feedback_button.png';
import '../DocumentationPages.css';

const OverView = () => {
  return (
    <div
      style={{
        backgroundColor: '#CEDBD6',
        backgroundSize: 'cover',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',

        padding: '35px 15% 35px 10%',
      }}
    >
      The California Wildfire Commons serves as a federated platform that brings
      together diverse wildfire and landscape related data into a single,
      accessible system. It advances California’s Million Acre Strategy. It will
      provide centralized data access that will enhance reporting and help
      federal and state agencies and land managers by providing data driven
      support on policy and decision making.
    </div>
  );
};
const CoreView = () => {
  return (
    <div
      style={{
        backgroundColor: '#CEDBD6',
        backgroundSize: 'cover',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',

        padding: '35px 15% 35px 10%',
      }}
    >
      <h3>
        <strong>Core Features</strong>
      </h3>
      {/* <h4>User Authentication and Role-based Access</h4> Upon registration and
      login, the WLR Datahub supports the following roles.
      <ul>
        <li>
          <u>General User</u> - These users can search, view, download,
          visualize, subset, and generate reports.
        </li>
        <li>
          <u>Data Publisher</u> - These users can submit datasets and manage
          their own draft datasets.
        </li>
        <li>
          <u>Approver</u> - These users can review and approve or reject
          submitted datasets.
        </li>
        <li>
          <u>Admin</u>- These users can submit datasets and manage their own
          draft datasets.
        </li>
      </ul>
      <hr /> */}
      <h4>Catalog</h4> A comprehensive CKAN-based catalog where users can access
      metadata and data. The catalog offers API endpoints for downloading and
      clipping data for seamless integration into other applications.{' '}
      <ul>
        <li>
          Interagency Tracking System (ITS) Data:
          <ul>
            <li>
              ITS Activity Report (Version 2.0, Version 1.1.1, Version 1.1, and
              Version 1.0)
            </li>{' '}
            <li>
              ITS Footprint Report (Version 2.0, Version 1.1 and Version 1.0)
            </li>
          </ul>
        </li>
        <li>CA Landscape Metrics (CLM) Data - 189 Datasets</li>
        <li>Boundary Data - 9 Boundary Datasets</li>
      </ul>
      <hr />
      <h4>Data Collections</h4> Customized Interactive dashboards and webpages
      presenting tailored wildfire data. Featured collections currently include
      the ITS and CLM datasets.
      <hr />
      <h4>Map Viewer</h4> A map interface for analytics and visualizations.
      Users can add and overlay data layers from the catalog, apply filters,
      subset datasets, define boundaries, and generate detailed reports.
      <ul>
        {/* <li>Download dataset from catalog</li> */}
        <li>Visualize multiple datasets</li>
        <li>Download individual data cropped to specific boundaries</li>
        <li>Generate custom reports using CLM and ITS datasets</li>
      </ul>
    </div>
  );
};
const StarterView = () => {
  return (
    <div
      style={{
        backgroundColor: '#CEDBD6',
        backgroundSize: 'cover',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '35px 15% 35px 10%',
      }}
    >
      <h3>
        <strong>Getting Started</strong>
      </h3>
      {/* <div style={{ display: 'flex' }}>
        <div>
          <h4>First-time Users: Register for a new account</h4>
          <ol>
            <li>
              Click on the user icon in the top-right corner.
              <img
                className="imgDisplay"
                height={50}
                style={{ margin: '8px 0px' }}
                src={login_create_account_image}
                alt="Screenshot of the user icon and account creation dropdown"
              />
            </li>
            <li>Select “Create Account” from the dropdown tab.</li>
            <li>
              Fill out the form with the required details.
              <ul>
                <li>
                  {' '}
                  After clicking submit, you may have to wait several seconds
                  for the system to process.
                </li>
              </ul>{' '}
            </li>
            <li>
              You will receive an email to complete your registration. Once you
              approve your account via the email link, you can log in using your
              new credentials.
              <ul>
                <li>Please check Spam folder if email not found</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>{' '}
      <hr />
      <h4>Returning Users: Log in with your credentials.</h4>
      <ol>
        <li>Click on the user icon in the top-right corner.</li>
        <li>Select “Login” from the dropdown tab.</li>
        <li>Enter your username and password.</li>
        <li>
          If you forgot your password, use the “Forgot Password?” link to reset
          it.
        </li>
      </ol>
      <hr /> */}
      <h4>Quick Setup for Visualizing Datasets on a Map</h4>
      <ol>
        <li>Navigate to the Catalog tab.</li>
        <li>
          Search for and add your desired datasets to your Map Viewer using the
          "Add to Map Viewer" button.
        </li>
        <li>Navigate to the Map Viewer tab and view your datasets on a map.</li>
      </ol>
    </div>
  );
};

const SupportView = () => {
  return (
    <div
      style={{
        backgroundColor: '#CEDBD6',
        backgroundSize: 'cover',
        flexGrow: 1,
        display: 'flex',
        height: '100%',

        padding: '35px 15% 35px 10%',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {/* <h3>Troubleshooting</h3>Problems? FAQs */}
        <h3>Support and Contact</h3>
        <h4>Feedback Form</h4>
        <ol>
          <li>Login into your account via user icon</li>
          <li>
            Click on the user icon in the top-right corner and select Feedback
          </li>
          <li>Select a topic of feedback via the drop down</li>
          <li>Add a comment clearly stating request or comment </li>
          <li>Press Send</li>
        </ol>
      </div>
      <img
        className="imgDisplay"
        height={250}
        src={feedback_button}
        style={{ marginLeft: '16px' }}
        alt="Screenshot of the feedback button and form"
      />
    </div>
  );
};

// const StarterView = () => {
//   return (
//     <div style={{ display: 'flex' }}>
//       <div
//         id="user_guide"
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           minHeight: '100vh',
//           minWidth: '88%',
//         }}
//       >
//         <div style={{ display: 'flex' }}>
//           <div
//             style={{
//               backgroundColor: '#CEDBD6',
//               backgroundSize: 'cover',
//               flexGrow: 1,
//               display: 'flex',
//               flexDirection: 'column',
//               height: '100%',

//               padding: '35px 15% 35px 10%',
//             }}
//           >
//             {' '}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
export { OverView, CoreView, StarterView, SupportView };
